import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Modal, Notification } from 'Components';
import { useModal } from 'Hooks/useModal';
import {
	Group,
	ResetGroupUsersPasswordsRequest,
	ResetGroupUsersPasswordsResponse
} from 'Services/Api/Groups/Types';
import { RESET_GROUP_USERS_PASSWORDS } from 'Services/Api/Groups/Mutations';
import { GroupModalsProps } from './types';
import { notifyUsersResetPasswordSuccess } from 'Pages/Users/components/UsersTableControls/UsersTableControls.helpers';
import TInfoText from 'Contexts/TInfoText/TInfoText';

export function ResetPasswordGroupModal(props: GroupModalsProps) {
	const { t } = useTranslation();
	const { modal, hideModal } = useModal();

	const [resetGroupUsersPasswords, result] = useMutation<
		ResetGroupUsersPasswordsResponse,
		ResetGroupUsersPasswordsRequest
	>(RESET_GROUP_USERS_PASSWORDS, {
		onCompleted: (data) => {
			props.onSubmit();
			notifyUsersResetPasswordSuccess(
				data?.resetGroupUsersPasswords.totalCount ?? 0
			);
			hideModal();
		},
		onError: (e) => {
			hideModal();

			Notification.error({
				description: e.message
			});
		}
	});

	if (!modal) {
		return null;
	}
	const group = modal.value as Group;

	const onSubmit = () => {
		resetGroupUsersPasswords({ variables: { id: group.id } });
	};

	return (
		<Modal
			visible
			title={
				<TInfoText
					path="groups.groupDetails.components.resetPasswordGroupModal.title"
					params={{ name: group.name }}
				/>
			}
			okText={t(
				'groups.groupDetails.components.resetPasswordGroupModal.okText'
			)}
			okButtonProps={{ loading: result.loading }}
			onOk={onSubmit}
			onCancel={hideModal}
		>
			{t('groups.groupDetails.components.resetPasswordGroupModal.body')}
		</Modal>
	);
}
